import Form from '@gef-ui/form-material/Form';
import { getLabelMessage } from '@gef-ui/localization/messages';

import Panel from 'components/atoms/GefMui/Panel';
import ResolverSettings from 'components/atoms/GefMui/ResolverSettings';
import SubmitFormDialog from 'components/atoms/GefMui/SubmitFormDialog/SubmitFormDialog';
import PAGES from 'constants/pages';
import formDescriptorFn, { MANUAL_LEAD_FORM_NAME } from 'features/views/taskCreatingPages/form';

import ActionButtons from '../components/ActionButtons';
import ClientInfo from '../components/ClientInfo';
import DetailInfo from '../components/DetailInfo';
import InformationPS from '../components/InformationPS';
import Note from '../components/Note';

const ManualLead = () => {
	return (
		<Form name={MANUAL_LEAD_FORM_NAME} formDescriptorFn={formDescriptorFn}>
			<Panel
				screenId={PAGES.taskCreatingPages.manualLead.id}
				screenName={PAGES.taskCreatingPages.manualLead.name}
				floatingDialogs={<SubmitFormDialog pageName={MANUAL_LEAD_FORM_NAME} />}
			>
				<DetailInfo
					formName={MANUAL_LEAD_FORM_NAME}
					subheaderTitle={getLabelMessage('taskCreatingPages:manualLead')}
				/>
				<Note />
				<InformationPS formName={MANUAL_LEAD_FORM_NAME} />
				<ClientInfo formName={MANUAL_LEAD_FORM_NAME} />
				<ResolverSettings formName={MANUAL_LEAD_FORM_NAME} />
				<ActionButtons formName={MANUAL_LEAD_FORM_NAME} />
			</Panel>
		</Form>
	);
};

export default ManualLead;
